<template>
  <a-modal
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    centered
    :title="$t('title.licenseSearch')"
    v-model="visible"
    width="65%">
    <a-space>
      <a-button type="primary" @click="confirm">{{ $t('button.confirm') }}</a-button>
      <a-button type="primary" @click="cancel">{{ $t('button.cancel') }}</a-button>
    </a-space>
    <br /><br />
    <a-table
      :customRow="onClickRow"
      :dataSource="data"
      :loading="loading"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:this.selectType,columnWidth:'50px'}"
      bordered
      size="small">
      <a-table-column :title="$t('business.label.index')" dataIndex="index" width="60px">
        <span slot-scope="text, record, index">{{ index + 1 }}</span>
      </a-table-column>
      <a-table-column :ellipsis="true" :title="$t('business.label.licenseNo')" align="center" dataIndex="licenseNo">
        <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
      </a-table-column>
      <a-table-column :ellipsis="true" :title="$t('business.label.expirationTime')" align="center" dataIndex="licenseExpirationDate">
        <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
      </a-table-column>
    </a-table>
  </a-modal>
</template>
<script>
import { post } from '@/api/Api'
import { STable } from '@/components'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import Api from '@/api'

export default {
  name: 'LicenseModal',
  components: { PageUtil, STable },
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { 'itemId': null },
      args: null,
      selectedRowKeys: [],
      selectedRows: [],
      record: undefined
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    }
  },
  methods: {
    init(args) {
      this.query = { 'itemId': null }
      this.data = []
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      this.getData()
    },
    getData() {
      this.onSelectChange([], [])
      if (this.query['itemId'] === null || this.query['itemId'] === undefined) {
        return this.$message.warning('请先选择商品')
      }
      this.loading = true
      post(Api.receivingAsnGetLicences, null, null, this.query)
        .then((res) => {
          if (res.success) {
            let i=1
            res.result.forEach(item=>{
              item.key=i++
            })
            setTimeout(() => {
              this.data = res.result
              this.loading = false
            }, 200)
          }
        })
    },
    onClickRow(record) {
      return {
        on: {
          click: () => {
            if (this.selectType === 'radio') {
              this.onSelectChange([record.key], [record])
            } else {
              const index = this.selectedRowKeys.indexOf(record.key)
              if (index === -1) {
                this.selectedRowKeys.push(record.key)
                this.selectedRows.push(record)
              } else {
                this.selectedRowKeys.splice(index, 1)
                this.selectedRows.splice(index, 1)
              }
            }
          },
          dblclick: () => {
            if (this.selectType === 'radio') {
              this.confirm()
            }
          }
        }
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    clearParam() {
      this.init(this.args)
    },
    handleCancel() {
      this.visible = false
    },
    confirm() {
      this.$emit('change', this.selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>
